<template>
  <section id="client-information-form-queues-section">
    <v-card-title class="font-weight-medium primary--text">
      Configuración de Colas
    </v-card-title>
    <queue-row
      v-for="(row, idx) in queuesArr"
      :row="row"
      :key="row.id"
      :showAdd="idx === 0"
      :showDelete="idx !== 0"
      :onAdd="handleAddRow"
      :onDelete="handleDeleteRow"
      @data:change="(data) => handleChangeRowFields(row.id, data)"
    ></queue-row>
  </section>
</template>

<script>
import QueueRow from "./QueueRow.vue";
export default {
  props: {
    queuesArr: {
      type: Array,
    },
  },

  components: {
    QueueRow,
  },

  methods: {
    autogenerateId() {
      return Math.floor(1000 + Math.random() * 9000);
    },

    /**
     * Dispatch the change event with the new Array
     *
     * @param  {Array} updated array
     *
     */
    changePayload(newArr) {
      this.$emit("queue:change", newArr);
    },

    /**
     * Update the row with the given data
     *
     * @param rowId {Number} id of the row to be updated
     * @param newData {Object} updated data
     * @param newData.field {string} name of the field to be updated
     * @param newData.value {string} new value
     *
     */
    handleChangeRowFields(rowId, { field, value }) {
      const newArr = this.queuesArr.map((el) => (el.id === rowId ? { ...el, [field]: value } : el));
      this.changePayload(newArr);
    },

    /**
     * Create a new row with an autogenerated ID
     */
    handleAddRow() {
      const newArr = [...this.queuesArr, { id: this.autogenerateId(), name: "", queue: "", group: "" }];
      this.changePayload(newArr);
    },

    /**
     * Remove the row of the given id
     */
    handleDeleteRow(id) {
      const newArr = this.queuesArr.filter((el) => el.id !== id);
      this.changePayload(newArr);
    },
  },
};
</script>

<style></style>
